import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";

interface AlertModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave?: (enabled: boolean) => void;
  isEnabled: boolean;
}

export function AlertModal({
  open,
  onOpenChange,
  onSave,
  isEnabled,
}: AlertModalProps) {
  const [enabled, setEnabled] = useState<boolean>(isEnabled);

  useEffect(() => {
    setEnabled(isEnabled);
  }, [isEnabled]);

  const handleSave = () => {
    onSave?.(enabled);
    onOpenChange(false);
  };

  const handleCheckboxChange = (checked: boolean) => {
    setEnabled(checked);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[450px] border border-gray-200 rounded-lg">
        {/* Header */}
        <DialogHeader>
          <DialogTitle>Alerts</DialogTitle>
        </DialogHeader>

        {/* Content */}
        <DialogInner className="space-y-6">
          {/* Alert Settings */}
          <div className="flex items-center gap-3">
            <Checkbox
              checked={enabled}
              onCheckedChange={handleCheckboxChange}
              className="h-5 w-5"
            />
            <span
              className="text-sm text-gray-900 leading-relaxed clickable select-none"
              onClick={() => handleCheckboxChange(!enabled)}
            >
              Email me a weekly assignments digest every Monday
            </span>
          </div>

          {/* Footer */}
          <Button
            intent="primary"
            onClick={handleSave}
            className="w-[100px] h-10"
          >
            Save
          </Button>
        </DialogInner>
      </DialogContent>
    </Dialog>
  );
}
